<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxLayoutGap="24px">
  <oneapp-header
    *ngIf="employeeGroupForm"
    [title]="getEmployeeGroupTitle()"
    (buttonClick)="onActionButtonClick($event)"
    [saveButtonConfig]="saveButtonConfig"
    [deleteButtonConfig]="deleteButtonConfig"
  ></oneapp-header>

  <!-- loading spinner -->
  <div *ngIf="loadingEmployeeGroup" fxFill fxLayoutAlign="center center">
    <fa-icon
      class="icon loading_spinner"
      [icon]="faSpinnerThird"
      aria-label="user settings button"
    ></fa-icon>
  </div>
  <form
    class="form_container"
    fxLayoutAlign="start stretch"
    fxLayout="column"
    fxLayoutGap="24px"
    [formGroup]="employeeGroupForm"
    (ngSubmit)="onSubmit()"
    id="employeeGroupFormID"
    *ngIf="employeeGroupForm && !loadingEmployeeGroup"
  >
    <div class="section">
      <div class="formelement_container" fxLayout="row">
        <mat-form-field id="employee_group_name" appearance="outline">
          <mat-label i18n="@@groupName">Group Name</mat-label>
          <input matInput placeholder="" formControlName="name" id="name" required />
          <mat-error *ngIf="employeeGroupForm.get('name')?.invalid" i18n="@@groupNameFeildRequired"
            >Group name is required</mat-error
          >
        </mat-form-field>
      </div>

      <div class="general_data" fxLayout="column" *ngIf="employeeGroup">
        <div class="properties" fxLayout="row" fxLayoutAlign="start center">
          <span class="task_properties_title" i18n="@@employeesLabel">Employees</span>
          <span class="task_properties_value">{{ employeeGroup.employees.length }}</span>
        </div>
        <div class="properties" fxLayout="row" fxLayoutAlign="start center">
          <span class="task_properties_title" i18n="@@supervisorsLabel">Supervisors</span>
          <span class="task_properties_value">{{ employeeGroup.supervisors.length }}</span>
        </div>
      </div>
    </div>
    <div class="section">
      <p class="section-title" i18n="@@employeesAndSupervisors">Employees and Supervisors</p>
      <app-chips-autocomplete
        id="employees"
        [title]="EMPLOYEES_TEXT"
        [inputPlaceholder]="EMPLOYEES_AUTOCOMPLETE_PLACEHOLDER"
        formControlName="employees"
        [allElements]="convertedEmployees"
      ></app-chips-autocomplete>
      <app-chips-autocomplete
        id="supervisors"
        [title]="SUPERVISORS_TEXT"
        [inputPlaceholder]="SUPERVISORS_AUTOCOMPLETE_PLACEHOLDER"
        formControlName="supervisors"
        [allElements]="convertedEmployees"
      ></app-chips-autocomplete>
    </div>
  </form>
</div>
